<template>
  <VueSplitter
    :margin="30"
    :horizontal="horizontal"
    style="display: flex; height:  100%; overflow: hidden "
  >
    <Groups
      slot="left-pane"
      @choice="choice"
    />
    <GroupInfo
      slot="right-pane"
      :group="cur_group"
      :clients="clients"
    />
  </VueSplitter>
</template>

<script>
import GroupInfo from './CustomDeviceList/CustomDeviceListInfo'
import Groups from './CustomDeviceList/CustomDeviceListGroups'
import VueSplitter from '@rmp135/vue-splitter'
export default {
  name: 'CustomDeviceList',
  components: {
    GroupInfo,
    VueSplitter,
    Groups
  },
  data () {
    return {
      new_group: '',
      cur_group: {},
      clients: [],
    }
  },
  mounted(){
    this.get_clients()
  },
  computed:{
    horizontal(){
      return document.documentElement.clientWidth <= 768;
    }
  },
  methods: {
    choice (group) {
      this.cur_group = group;
    },
    get_clients(){
      this.$http.v1.getClients((response) => {
        for (let i in response.data) {
          this.clients.push(response.data[i])
        }
      })
    }
  }
}
</script>
